__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/df7ca633dbe38c34ef62f76fbcc5d4e9ec62a7fb/_next/";